import { lazy } from 'react'
import type { RouteWithMeta } from '../types'
import { withSuspense } from '../utils/withSuspense'

// Lazy loading으로 성능 최적화
const TagPage = lazy(() => import('@/pages/tag/TagPage'))

/**
 * 태그 관리 라우트
 * children 없이 flat하게 구성 → 사이드바에 화살표 안 나타남
 */
export const tagRoutes: RouteWithMeta[] = [
  {
    path: 'tag',
    element: withSuspense(<TagPage/>),
    meta: {
      label: '태그',
      showInMenu: true,
      icon: ''
    }
  },
]